import React, { Fragment } from "react";

//components
import BreadCrumb from "../../components/breadcrumb/breadcrumb";
import { ToastContainer, toast } from "react-toastify";
import { customerService } from "../../actions/customersupport";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Alert from "../../components/alert/alert.component";
import {
  TextField,
  FormControl,
  OutlinedInput,
  Input,
  InputLabel,
  InputAdornment,
} from "@material-ui/core";

class CustomerService extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: "",
      _name: "",
      email: "",
      alertMsg: "Your Query Has Been Sent",
      topic: "",
      message: "",
      messageMessage: "",
      firstNameError: "",
      emailError: "",
      lastNameError: "",
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }
  handleFirstNameChange = (e) => {
    const target = e.target;
    if (
      target.value.charAt(0) === "0" ||
      target.value.charAt(0) === "1" ||
      target.value.charAt(0) === "2" ||
      target.value.charAt(0) === "3" ||
      target.value.charAt(0) === "4" ||
      target.value.charAt(0) === "5" ||
      target.value.charAt(0) === "6" ||
      target.value.charAt(0) === "7" ||
      target.value.charAt(0) === "8" ||
      target.value.charAt(0) === "9" ||
      target.value.length < 3
    ) {
      console.log("handleUsernameChange()");
      this.setState({
        _name: target.value,
        firstNameError: "Enter Your Correct Name",
      });
    } else {
      this.setState({
        _name: target.value,
        firstNameError: "",
      });
    }
  };
  handleLastNameChange = (e) => {
    const target = e.target;
    if (target.value.length < 10) {
      console.log("handleUsernameChange()");
      this.setState({
        message: target.value,
        lastNameError: "Message must be 10 characters long",
      });
    } else {
      this.setState({
        message: target.value,
        lastNameError: "",
      });
    }
  };
  handleEmailNameChange = (e) => {
    const target = e.target;
    const regexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!regexp.test(target.value)) {
      this.setState({
        email: target.value,
        emailError: "Enter Valid Email",
      });
    } else {
      this.setState({
        email: target.value,
        emailError: "",
      });
    }
  };
  _submitHandler = async (e) => {
    const {
      _name,
      email,
      topic,
      message,
      messageMessage,
      firstNameError,
      emailError,
      lastNameError,
    } = this.state;

    if (
      _name.charAt(0) === "0" ||
      _name.charAt(0) === "1" ||
      _name.charAt(0) === "2" ||
      _name.charAt(0) === "3" ||
      _name.charAt(0) === "4" ||
      _name.charAt(0) === "5" ||
      _name.charAt(0) === "6" ||
      _name.charAt(0) === "7" ||
      _name.charAt(0) === "8" ||
      _name.charAt(0) === "9" ||
      _name.length < 3
    ) {
      this.setState({
        firstNameError: "Enter Your Correct Name",
      });
      return;
    }

    const regexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!regexp.test(email) || email.length < 1) {
      this.setState({ emailError: "Enter Valid email" });
      return;
    }
    if (message.length < 1) {
      this.setState({
        lastNameError: "Message should be required",
      });
      return;
    }
    const formData = {
      _name,
      email,
      topic,
      message,
    };

    const res = await this.props.customerService(formData);

    this.setState({ loading: false });

    if (res) {
      // toast(`${"Your Query Has been Sent"}`, { containerId: "B" });

      this.setState({
        _name: "",
        email: "",
        topic: "",
        message: "",
        loading: false,
        messageMessage: this.state.alertMsg,
        class: "alert-success",
      });
    } else {
      /* this.setState({
        messageMessage: "Fill All the field",
        class: "alert-danger",
      }); */
      // toast.error(`${"Fill All the field"}`, { containerId: "B" });
    }
  };
  render() {
    const { email, _name, topic, message } = this.state;
    return (
      <Fragment>
        <ToastContainer
          enableMultiContainer
          containerId={"B"}
          position={toast.POSITION.TOP_RIGHT}
        />
        <div className="customerServices-wrapper wrapper-90 max-1600">
          <BreadCrumb title={`Customer Support`} />
          <div className="container-fluid map-container">
            <div className="row">
              <div className="col-md-12">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12581.973936669883!2d-122.05640651713698!3d37.96561127263135!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808566cde96f4ba5%3A0xa24ccd5b793c23ab!2s1301+Franquette+Ave%2C+Concord%2C+CA+94520%2C+USA!5e0!3m2!1sen!2sin!4v1559078220082!5m2!1sen!2sin"
                  width="100%"
                  height={350}
                  frameBorder={0}
                  style={{ border: 0 }}
                  allowFullScreen
                  aria-hidden="false"
                  tabIndex={0}
                  title="google map"
                />
              </div>
            </div>
          </div>
          <main className="customerServ-main">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-4">
                  <div className="customerServ-contact">
                    <div className="customerServ-contact-content">
                      <div className="customerServ-headquater">
                        <span className="customerServ-location-icon cus-icon">
                          <i className="fa fa-map-marker-alt" />
                        </span>
                        <div className="customerServ-headquater-info">
                          <h4 className="customerServ-contact-heading">
                            HEADQUARTERS
                          </h4>
                          <span className="customerServ-contact-txt">
                            Sundial Home Products LLC. <br /> 1301 Franquette
                            Avenue, Concord, CA 94520 <br /> Email:
                            admin@sundialhomeproducts.com
                          </span>
                        </div>
                      </div>
                      <hr />
                      <a href="tel:18889690452" className="customerServ-call">
                        <span className="customerServ-contact-icon cus-icon">
                          <i className="fa fa-phone" />
                        </span>
                        <div className="customerServ-call-info">
                          <h4 className="customerServ-contact-heading call-cus">
                            Call Us
                          </h4>
                          <span className="customerServ-contact-txt">
                            Tel: +1 (888) 969-0452
                          </span>
                        </div>
                      </a>
                      <hr />
                      <div className="customerServ-hours">
                        <span className="customerServ-hours-icon cus-icon">
                          <i className="fa fa-clock" />
                        </span>
                        <div className="customerServ-hour-content">
                          <h4 className="customerServ-contact-heading">
                            STORE HOURS
                          </h4>
                          <p className="m-0 customerServ-contact-txt">
                            Mon - Fri: 8AM - midnight
                          </p>
                          <p className="m-0 customerServ-contact-txt">
                            Sat: 8AM - 8PM
                          </p>
                          <p className="m-0 customerServ-contact-txt">
                            Sun: 9AM - 6PM
                          </p>
                          <p className="m-0 customerServ-contact-txt">
                            Sat: 8AM - 8PM
                          </p>
                          <p className="m-0 customerServ-contact-txt">
                            All Times Pacific
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="shippingRates-body" style={{ marginTop: 0 }}>
                    <header className="shiping-content-header text-center">
                      <h3 className="shipping-rate-title">
                        Looking forward to hearing from you
                      </h3>
                    </header>
                    <div className="shippingRates-method-card">
                      <div className="shippingRates-inputs-container">
                        <label
                          htmlFor="yourname"
                          className="shippingRates-input-field"
                        >
                          <FormControl variant="outlined" className="my-2">
                            <TextField
                              variant="outlined"
                              id="component-outlined"
                              name="firstName"
                              value={_name && _name}
                              onChange={(e) => {
                                this.handleFirstNameChange(e);
                              }}
                              error={
                                this.state.firstNameError &&
                                this.state.firstNameError !== ""
                                  ? true
                                  : false
                              }
                              label="First Name"
                              helperText={
                                this.state.firstNameError &&
                                this.state.firstNameError
                              }
                            />
                          </FormControl>
                          {/*     <input
                            type="text"
                            className="shippingRates-input"
                            name="name"
                            value={_name && _name}
                            onChange={(el) => {
                              this.setState({ _name: el.target.value });
                            }}
                          /> */}
                        </label>
                        <label
                          htmlFor="zipto"
                          className="shippingRates-input-field"
                        >
                          <FormControl variant="outlined" className="my-2">
                            <TextField
                              variant="outlined"
                              id="component-outlined"
                              type="email"
                              name="email"
                              maxLength={96}
                              value={email && email}
                              onChange={(e) => {
                                this.handleEmailNameChange(e);
                              }}
                              error={
                                this.state.emailError &&
                                this.state.emailError !== ""
                                  ? true
                                  : false
                              }
                              label="Email Address"
                              helperText={
                                this.state.emailError && this.state.emailError
                              }
                            />
                          </FormControl>
                          {/*  <input
                            type="text"
                            className="shippingRates-input"
                            name="email"
                            id="email"
                            value={email && email}
                            onChange={(el) => {
                              this.setState({ email: el.target.value });
                            }}
                          />
                          <span className="shippingRates-inp-placeholder">
                            Your Email
                          </span> */}
                        </label>
                        <div className="checkout-inps">
                          <span className="selectcountry-hint">
                            Select Topic
                          </span>
                          <select
                            className="countrySelect"
                            name="topic"
                            id="topic"
                            value={topic && topic}
                            onChange={(el) => {
                              this.setState({ topic: el.target.value });
                            }}
                          >
                            <option value="select Topic" disabled>
                              Select country
                            </option>
                            <option value="Order Assistance">
                              Order Assistance
                            </option>
                            <option value="Shipping">Shipping</option>
                            <option value="General Product Inquiry">
                              General Product Inquiry
                            </option>
                            <option value="Special Request">
                              Special Request
                            </option>
                            <option value="Report a bug">Report a bug</option>
                          </select>
                        </div>
                        <div className="store-card-header">
                          <FormControl variant="outlined" className="my-2">
                            <TextField
                              variant="outlined"
                              id="component-outlined"
                              type="message"
                              name="message"
                              maxLength={96}
                              value={message && message}
                              onChange={(e) => {
                                this.handleLastNameChange(e);
                              }}
                              error={
                                this.state.lastNameError &&
                                this.state.lastNameError !== ""
                                  ? true
                                  : false
                              }
                              label="Message"
                              helperText={
                                this.state.lastNameError &&
                                this.state.lastNameError
                              }
                            />
                          </FormControl>
                          {/*   <span>Message</span>
                          <textarea
                            name="message"
                            value={message && message}
                            onChange={(el) => {
                              this.setState({
                                message: el.target.value,
                              });
                            }}
                            className="store-textarea"
                            id="store-address-detail"
                            cols={75}
                            rows={2}
                            defaultValue={""}
                          /> */}
                        </div>
                        <hr />
                        <div className="shippingRates-refineBtn">
                          <button
                            className="refineSearch"
                            onClick={(e) => {
                              this._submitHandler(e);
                            }}
                          >
                            <span>Submit</span>
                          </button>
                        </div>
                        {this.state.messageMessage && (
                          <div
                            className={`alert ${this.state.class}`}
                            role="alert"
                            style={{
                              width: "100%",
                              marginBottom: "2%",
                              marginTop: "2%",
                              borderRadius: "20px",
                            }}
                          >
                            {this.state.messageMessage}
                          </div>
                        )}
                        <Alert />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </Fragment>
    );
  }
}
customerService.propTypes = {
  customerService: PropTypes.func.isRequired,
};

export default connect(null, { customerService })(CustomerService);
